import * as z from 'zod';
import { percentSchemaV2 } from '../opaque.mjs';

const extractionFieldMetadata = {
    sourceLabel: z.string().nullish(),
    explanation: z.string().nullish(),
};
const extractionFieldSchema = (value) => z.object({
    value,
    ...extractionFieldMetadata,
});
const stringExtractionFieldSchema = extractionFieldSchema(z.string().nullish());
const numberExtractionFieldSchema = extractionFieldSchema(z.number().nullish());
const percentExtractionFieldSchema = extractionFieldSchema(percentSchemaV2.nullish());
extractionFieldSchema(z.boolean());
const nullableBooleanExtractionFieldSchema = extractionFieldSchema(z.boolean().nullish());

export { extractionFieldSchema, nullableBooleanExtractionFieldSchema, numberExtractionFieldSchema, percentExtractionFieldSchema, stringExtractionFieldSchema };
